export class JsonContainer {
  success: boolean
  desc: string
}
